import { Navigate, useLocation } from 'react-router-dom';

import { Spinner } from '../components/ui/Spinner.jsx';

import { useAuth } from './useAuth.js';

export function ProtectedRoute({ children, publicHome = null }) {
  const { isAuthenticated, isBootstrapping } = useAuth();
  const location = useLocation();

  if (isBootstrapping) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <Spinner />
      </div>
    );
  }
  if (!isAuthenticated) {
    // The public landing page lives on '/' only; every other app path still
    // redirects to the login as before.
    if (publicHome && location.pathname === '/') {
      return publicHome;
    }
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
